import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Paper,
  Container,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";

import { AuthContext } from "../../AuthContext/AuthContext";
import BottomNavbar from "../../Users/Rent Module/BottomNavbar/BottomNavbar";

const User_BankAuction = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `https://landnest.net:81/auction-property/?userId=${userId}`
        );
        setData(res.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load bank auction properties");
        setLoading(false);
      }
    };
    fetchData();
  }, [userId]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)), url('/construction4.png')`,
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        pb: 8,
      }}
    >
      <AppBar
        position="static"
        elevation={0}
        sx={{
          background: `linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)), url('/construction5.png')`,
          color: "#fff",
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{
              color: "#ffffff",
              backgroundColor: "rgba(255,255,255,0.1)",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>

          <Typography variant="h6" sx={{ ml: 2, fontWeight: 600 }}>
            My Bank Auction Properties
          </Typography>
        </Toolbar>
      </AppBar>

      <Container sx={{ py: 2 }}>
        {loading && (
          <Typography align="center" sx={{ mt: 3 }}>
            Loading...
          </Typography>
        )}

        {error && (
          <Typography color="error" align="center" sx={{ mt: 3 }}>
            {error}
          </Typography>
        )}

        {!loading &&
          !error &&
          data.map((item) => (
            <Paper
              key={item.bankprop_id}
              sx={{
                p: 2,
                mb: 2,
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                background: "rgba(255,255,255,0.85)",
                backdropFilter: "blur(10px)",
              }}
            >
              {/* ID Info */}
              <Typography sx={{ fontWeight: 700, mb: 1 }}>
                <strong>BankProp ID:</strong> {item.bankprop_id} 
                {/* <strong>Auction ID:</strong> {item.auction_id || "N/A"} */}
              </Typography>

              <Typography>
                <strong>Property Type:</strong>{" "}
                <span style={{ color: "green" }}>{item.property_type}</span>
              </Typography>

              <Typography>
                <strong>Location:</strong> {item.location}
              </Typography>
              <Typography>
                <strong>City/Town:</strong> {item.city_town}
              </Typography>
              <Typography>
                <strong>Area Town:</strong> {item.area_town}
              </Typography>
              <Typography>
                <strong>Area:</strong> {item.area} {item.units || ""}
              </Typography>
              <Typography>
                <strong>Possession:</strong> {item.possession}
              </Typography>
              <Typography>
                <strong>Possession Status:</strong> {item.possession_status}
              </Typography>
              <Typography>
                <strong>Reserve Price:</strong> ₹
                {Number(item.reserve_price).toLocaleString()}
              </Typography>
              <Typography>
                <strong>EMD Amount:</strong> ₹
                {Number(item.emd_amount).toLocaleString()}
              </Typography>
              <Typography>
                <strong>Bid Increment:</strong> ₹
                {Number(item.bid_increment).toLocaleString()}
              </Typography>
              <Typography>
                <strong>EMD Submission:</strong>{" "}
                {new Date(item.emd_submission).toLocaleString()}
              </Typography>
              {item.auction_start_datetime && (
                <Typography>
                  <strong>Auction Start:</strong>{" "}
                  {new Date(item.auction_start_datetime).toLocaleString()}
                </Typography>
              )}
              {item.auction_end_datetime && (
                <Typography>
                  <strong>Auction End:</strong>{" "}
                  {new Date(item.auction_end_datetime).toLocaleString()}
                </Typography>
              )}
              <Typography>
                <strong>Contact:</strong> {item.bank_contact_details || "N/A"}
              </Typography>
              {item.download_auction_file && (
                <Typography>
                  <strong>File:</strong> {item.download_auction_file}
                </Typography>
              )}
              {item.description && (
                <Typography>
                  <strong>Description:</strong> {item.description}
                </Typography>
              )}

              <Typography sx={{ fontSize: "12px", opacity: 0.6, mt: 1 }}>
                Posted on: {new Date(item.created_at).toLocaleString()}
              </Typography>
            </Paper>
          ))}
      </Container>

      <BottomNavbar />
    </Box>
  );
};

export default User_BankAuction;
